/**
 * All the words on the page, in plain language.
 *
 * The bugs and fixes in CASES are real: each one is a published upstream fix
 * from the dataset (collected-data/rsi-pairs-v1/pairs/<id>). The "story" and
 * "rule" lines are examples written for this demo. The pipeline has not
 * generated lessons yet, so don't present them as its output.
 */

/** The loop, screen one. */
export const STEPS = [
  { key: "check", name: "Check", line: "The AI reviews code for security bugs." },
  { key: "feedback", name: "Feedback", line: "People confirm what was real and what was a false alarm." },
  { key: "learn", name: "Learn", line: "Each case is turned into a lesson." },
  { key: "update", name: "Update", line: "The lesson becomes a new rule in its skill." },
] as const;

/** Real bug-and-fix pairs from the learning set, told simply. Screen two. */
export const CASES = [
  {
    id: "pyjwt-hist-003",
    topic: "Empty key",
    library: "PyJWT",
    does: "checks login tokens",
    bug: "An empty secret key was accepted when checking a login token.",
    fix: "Empty keys are now rejected.",
    story: "There were two ways to pass in a key. One of them skipped the key check.",
    rule: "Every path must run the same safety checks.",
  },
  {
    id: "httpx-hist-002",
    topic: "Leaked password",
    library: "HTTPX",
    does: "sends web requests",
    bug: "A password written inside a web address ended up in a request header.",
    fix: "The password is removed before the header is built.",
    story: "The header was copied from the full address, password and all.",
    rule: "Strip secrets before reusing data elsewhere.",
  },
  {
    id: "httpx-hist-003",
    topic: "Wrong recipient",
    library: "HTTPX",
    does: "sends web requests",
    bug: "When a request was redirected to another website, the login details went with it.",
    fix: "Login details now stay with the original site.",
    story: "The login was added again after every redirect, no matter where the request was going.",
    rule: "New destination: re-check who gets the login.",
  },
  {
    id: "jinja-hist-001",
    topic: "Sneaky characters",
    library: "Jinja",
    does: "builds web pages",
    bug: "A few special characters in a tag name could slip extra HTML into a page.",
    fix: "Names with those characters are now refused.",
    story: "Only spaces were blocked. Three other characters did the same damage.",
    rule: "Block every dangerous character, not just one.",
  },
  {
    id: "werkzeug-hist-003",
    topic: "Endless form",
    library: "Werkzeug",
    does: "runs web servers",
    bug: "A form split into a huge number of parts could overload the server.",
    fix: "Forms now have a maximum number of parts.",
    story: "The size of a form was limited. The number of parts was not.",
    rule: "Limit anything outsiders can make you repeat.",
  },
] as const;
